module.exports = __webpack_public_path__ + "media/stylesheets/images/martech-1-7a4d081a8711c4dcaa9d94bddc8d511a.jpg";